var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty3 = function SvgEmpty3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 708,
    height: 200,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    d: "M321.239-.338h50.762c10.933 0 19.797 8.864 19.797 19.797v160.407c0 10.933-8.864 19.796-19.797 19.796h-50.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2A84D",
    d: "M321.239 199.662h-50.761c-10.934 0-19.797-8.863-19.797-19.797V19.459c0-10.933 8.863-19.797 19.797-19.797h50.761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBE6CC",
    d: "M361.206 32.657a5.838 5.838 0 1 1 0 11.676h-78.68a5.838 5.838 0 1 1 0-11.676zM361.206 73.267a5.838 5.838 0 1 1 0 11.675h-78.68a5.838 5.838 0 1 1 0-11.675zM361.206 113.876a5.837 5.837 0 1 1 0 11.675h-78.68a5.838 5.838 0 0 1 0-11.675zM361.206 154.485a5.837 5.837 0 1 1 0 11.675h-78.68a5.838 5.838 0 0 1 0-11.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000046",
    d: "M450.964 60.937h-90.862a5.035 5.035 0 0 0-5.035 5.035v66.729a5.036 5.036 0 0 0 5.035 5.036h31.819a.63.63 0 0 1 .457.196l6.915 7.299a6.6 6.6 0 0 0 9.581 0l6.915-7.299a.63.63 0 0 1 .457-.196h34.718a5.036 5.036 0 0 0 5.036-5.036V65.973a5.036 5.036 0 0 0-5.036-5.036"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M416.286 124.131c-13.631 0-24.68-11.05-24.68-24.68 0-13.631 11.049-24.681 24.68-24.681h4.834a4.377 4.377 0 1 1 0 8.753h-4.834c-8.797 0-15.928 7.13-15.928 15.927s7.131 15.928 15.928 15.928h4.834a4.377 4.377 0 1 1 0 8.753z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M383.868 94.616a4.377 4.377 0 0 1 4.377-4.377h25.138a4.376 4.376 0 1 1 0 8.753h-25.138a4.377 4.377 0 0 1-4.377-4.376M383.868 106.218a4.377 4.377 0 0 1 4.377-4.376h25.138a4.376 4.376 0 1 1 0 8.753h-25.138a4.377 4.377 0 0 1-4.377-4.377",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h708v200H0z"
  })))));
};
export default SvgEmpty3;